import React from "react";

import "./Info.scss";

import peopleIcon from "../../../assets/icons/people.svg";
import codeIcon from "../../../assets/icons/code.svg";
import trophyIcon from "../../../assets/icons/trophy.svg";
import { useTranslation } from "react-i18next";

const Info = () => {
  const { t } = useTranslation();

  return (
    <div className="info-content">
      <div className="main-info">
        <div className="info-text">
          <h2>{t("infoTitle")}</h2>
          <p>
            {t("infoBody")}
          </p>
        </div>
        <div className="info-image">
          <img src="/img/hackathon.png" alt="" />
        </div>
      </div>
      <h2>{t("statTitle")}</h2>
      <div className="stats-container">
        <div className="stat-box">
          <div className="stat-icon">
            <img src={peopleIcon} alt="" />
          </div>
          <div className="stat-description">
            <h2>350+</h2>
            <p>{t("hackers")}</p>
          </div>
        </div>
        <div className="stat-box">
          <div className="stat-icon">
            <img src={codeIcon} alt="" />
          </div>
          <div className="stat-description">
            <h2>60+</h2>
            <p>{t("projects")}</p>
          </div>
        </div>
        <div className="stat-box">
          <div className="stat-icon">
            <img src={trophyIcon} alt="" />
          </div>
          <div className="stat-description">
            <h2>$10k+</h2>
            <p>{t("inRewards")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
